(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  /* ---------- PRELOAD HIDDEN VARIANT IMAGES ---------- */
  // After swiper init, preload images from non-active slides so variant switching is instant
  function preloadHiddenImages() {
    // Force lazy images to load by changing loading attribute to eager
    var hiddenImages = document.querySelectorAll('.media-gallery_gallery-top .swiper-slide:not(.swiper-slide-active) img[loading="lazy"]');
    hiddenImages.forEach(function(img) {
      img.setAttribute('loading', 'eager');
      // Force browser to re-evaluate by touching src
      if (img.src) {
        var currentSrc = img.src;
        img.src = '';
        img.src = currentSrc;
      }
    });
    // Preload thumbnail images as well
    var thumbImages = document.querySelectorAll('.media-gallery_gallery-thumbs .swiper-slide img[loading="lazy"]');
    thumbImages.forEach(function(img) {
      img.setAttribute('loading', 'eager');
      if (img.src) {
        var currentSrc = img.src;
        img.src = '';
        img.src = currentSrc;
      }
    });
  }

  /* ---------- THUMB STRIP ---------- */
  const galleryThumbs = new Swiper('.media-gallery_gallery-thumbs', {
    cssMode: false,
    direction: 'horizontal',
    navigation: {
      nextEl: '#media-gallery_thumbs-next',
      prevEl: '#media-gallery_thumbs-prev',
    },
    spaceBetween: 4,
    slidesPerView: 'auto',
    freeMode: true,
    freeModeSticky: true,
    watchOverflow: true,
    mousewheel: { forceToAxis: true },
    touchReleaseOnEdges: true,
    resistanceRatio: 0,
    breakpoints: {
      1001: {
        direction: 'vertical',
        slidesPerView: 6,
        spaceBetween: 8,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
  });

  /* ---------- VIDEO HELPERS ---------- */
  function autoplayVideo(slider) {
    const activeSlide = slider.slides[slider.activeIndex];
    const activeVideo = activeSlide?.querySelector('video.js-lazy-video');
    if (!activeVideo) return;

    if (activeVideo.dataset.loaded === 'false') {
      activeVideo.querySelectorAll('source[data-source]').forEach(s => {
        if (!s.src) s.src = s.dataset.source;
      });
      activeVideo.load();
      activeVideo.dataset.loaded = 'true';
    }

    /* Enable inline playback, then attempt to play once. */
    activeVideo.setAttribute('playsinline', '');
    activeVideo.autoplay = true;
    activeVideo.play().catch(() => {});
  }

  function pauseAllVideos(slider) {
    slider.el.querySelectorAll('video').forEach(v => v.pause());
  }

  /* ---------- MAIN GALLERY ---------- */
  // Enable infinite loop on mobile when there are more than 4 slides
  const containerEl = document.querySelector('.media-gallery_swiper-container-wrapper');
  const availableCount = parseInt(containerEl?.getAttribute('data-available-count') || '0', 10);
  const isMobileViewport = window.matchMedia('(max-width: 1000px)').matches;
  const enableMobileLoop = isMobileViewport && availableCount > 4;
  const galleryTop = new Swiper('.media-gallery_gallery-top', {
    slidesPerView: 'auto',
    direction: 'horizontal',
    spaceBetween: 10,
    speed: 300,
    touchReleaseOnEdges: true,
    touchStartPreventDefault: false,
    loop: enableMobileLoop,
    pagination: {
      el: '.media-gallery_swiper-pagination',
      type: 'bullets',
      horizontalClass: 'swiper-pagination-horizontal',
    },
    navigation: {
      nextEl: '.media-gallery_swiper-button-next',
      prevEl: '.media-gallery_swiper-button-prev',
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    keyboard: { enabled: true },
    thumbs: { swiper: galleryThumbs },
    breakpoints: {
      1001: {
        direction: 'vertical',
        fadeEffect: { crossFade: true },
      },
    },
  });

  /* ---------- REMOVE FADE AFTER 500ms ---------- */
  setTimeout(function() {
    var wrapper = document.querySelector('.media-gallery_swiper-container-wrapper');
    if (wrapper) {
      wrapper.classList.add('js-loaded');
    }
    preloadHiddenImages();
  }, 500);

  /* ---------- SYNC / AUTOPLAY ---------- */
  galleryTop.on('slideChange', () => {
    // Trigger a touch tap event on the screen when slide changes
    const touchEvent = new Event('touchstart', { bubbles: true, cancelable: true });
    document.body.dispatchEvent(touchEvent);
    pauseAllVideos(galleryTop);
    autoplayVideo(galleryTop);
  });

  galleryTop.on('slideChangeTransitionStart', () => {
    galleryThumbs.slideTo(galleryTop.realIndex);
  });

  /* ---------- CLICK TO CHANGE ---------- */
  // In loop mode Swiper reorders the slides in place, so a slide's position in
  // the DOM stops matching its media index. Read the media index off the slide
  // rather than trusting its position.
  function mediaIndexOf(slide) {
    return parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
  }

  // Clicking a slide in the slider travels to the image that was clicked, so it
  // moves the way that image is sitting on screen.
  galleryTop.on('click', () => {
    const slide = galleryTop.clickedSlide;
    if (!slide || slide.classList.contains('swiper-slide-active')) return;

    if (galleryTop.params.loop) {
      const mediaIndex = mediaIndexOf(slide);
      if (!Number.isNaN(mediaIndex)) galleryTop.slideToLoop(mediaIndex);
    } else if (galleryTop.clickedIndex !== galleryTop.activeIndex) {
      galleryTop.slideTo(galleryTop.clickedIndex);
    }
  });

  // Looping belongs to the slider, not to the thumbnails. Put the slides back in
  // their natural order first (keeping the current one on screen) so a thumbnail
  // always travels in media order: an earlier thumbnail moves backwards, a later
  // one forwards, rather than wrapping whichever way Swiper's rotated DOM is
  // currently shorter.
  function goToMedia(mediaIndex) {
    if (Number.isNaN(mediaIndex) || galleryTop.realIndex === mediaIndex) return;

    if (galleryTop.params.loop) {
      const anchor = galleryTop.realIndex;
      Array.from(galleryTop.slides)
        .sort((a, b) => mediaIndexOf(a) - mediaIndexOf(b))
        .forEach((slide) => {
          slide.swiperLoopMoveDOM = true;
          galleryTop.slidesEl.append(slide);
          slide.swiperLoopMoveDOM = false;
        });
      galleryTop.recalcSlides();
      galleryTop.updateSlides();
      galleryTop.slideTo(anchor, 0, false, true);
      // Flush the reordering to the screen before the animated move below, so
      // the transition covers the distance between the two images and not the
      // re-anchoring as well.
      galleryTop.wrapperEl.getBoundingClientRect();
    }

    galleryTop.slideTo(mediaIndex);
  }

  // Hand thumbnail navigation to the listener below so it goes through
  // goToMedia. The thumbs module keeps owning the active-thumbnail class and
  // the strip scrolling; only its own slideToLoop-on-tap is dropped.
  galleryThumbs.off('tap');

  document
    .querySelectorAll('.media-gallery_gallery-thumbs .swiper-slide')
    .forEach((slide, i) => slide.addEventListener('click', () => goToMedia(i)));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["repurpose-impact"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.repurposeImpactInitialized) return;
    window.repurposeImpactInitialized = true;

    var EXPLAINER_ORIGIN = 'https://app.repurpose.global';

    function frameOf(dialog) {
      return dialog ? dialog.querySelector('[data-repurpose-frame]') : null;
    }

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-repurpose-open]');
      if (opener) {
        var dialog = document.getElementById(opener.getAttribute('data-repurpose-open'));
        if (!dialog) return;

        var frame = frameOf(dialog);
        if (frame && !frame.src && frame.dataset.src) frame.src = frame.dataset.src;

        dialog.showModal();
      }
    });

    document.addEventListener('click', function (event) {
      var dialog = event.target;
      if (!dialog.matches || !dialog.matches('[data-repurpose-dialog][open]')) return;

      var box = dialog.getBoundingClientRect();
      var outside =
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom;

      if (outside) dialog.close();
    });

    window.addEventListener('message', function (event) {
      if (event.origin !== EXPLAINER_ORIGIN) return;
      if (!event.data || event.data.type !== 'RPG_CLOSE_MODAL') return;

      document.querySelectorAll('[data-repurpose-dialog][open]').forEach(function (dialog) {
        var frame = frameOf(dialog);
        if (frame && event.source === frame.contentWindow) dialog.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
